(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class ProductCardForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Wait for next tick to allow DOM manipulation to complete
      setTimeout(() => {
        this.initializeComponent();
      }, 0);
    }

    initializeComponent() {
      // Find elements after the component is connected to DOM and content is moved
      this.selector = this.querySelector('.variant-selector');
      this.trigger = this.querySelector('.variant-selector__trigger');
      this.label = this.querySelector('.variant-selector__label');
      this.optionsContainer = this.querySelector('.variant-selector__options');
      this.options = this.querySelectorAll('.variant-selector__option');
      this.productImage = this.closest('.product-card')?.querySelector('.product-card__image-img');
      this.form = this.querySelector('.product-card__form');
      this.variantInput = this.form?.querySelector('.variant-id-input');
      this.submitButton = this.form?.querySelector('button[type="submit"]');

      // Quantity selector elements
      this.quantitySelector = this.querySelector('.product-card__quantity-selector');
      this.quantityInput = this.quantitySelector?.querySelector('.quantity-input');
      this.quantityMinusBtn = this.quantitySelector?.querySelector('.quantity-btn--minus');
      this.quantityPlusBtn = this.quantitySelector?.querySelector('.quantity-btn--plus');

      // B2B total price target (card price)
      const cardRoot = this.closest('.product-card');
      this.cardPriceEl = cardRoot?.querySelector('[data-role="product-card-price"]');
      this.b2b = cardRoot?.getAttribute('data-b2b') === 'true';

      this.isOpen = false;
      this.activeOptionIndex = 0;

      this.init();
    }

    init() {
      // Handle variant selector if it exists
      if (this.selector && this.options.length > 0) {
        // Handle trigger click
        this.trigger.addEventListener('click', this.handleTriggerClick.bind(this));
        this.trigger.addEventListener('keydown', this.handleTriggerKeydown.bind(this));

        // Handle option selection
        this.options.forEach((option, index) => {
          option.addEventListener('click', () => this.handleOptionSelect(index));
          option.addEventListener('keydown', (event) => this.handleOptionKeydown(event, index));
        });

        // Handle click outside to close
        document.addEventListener('click', this.handleOutsideClick.bind(this));
      }

      // Handle form submission (always attach if form exists)
      if (this.form) {
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
      }

      // Handle quantity selector if it exists
      if (this.quantitySelector && this.quantityInput) {
        this.quantityMinusBtn?.addEventListener('click', this.handleQuantityDecrease.bind(this));
        this.quantityPlusBtn?.addEventListener('click', this.handleQuantityIncrease.bind(this));
        this.quantityInput.addEventListener('change', this.handleQuantityChange.bind(this));
        this.quantityInput.addEventListener('input', this.validateQuantity.bind(this));

        // Initialize button states
        this.updateQuantityButtons();
        // Initialize B2B caps and total
        if (this.b2b) {
          if (this.selector && this.options && this.options.length > 0) {
            // Enforce cap based on initially selected option
            const initiallySelected =
              Array.from(this.options).find((o) => o.getAttribute('aria-selected') === 'true') || this.options[0];
            if (initiallySelected) this.enforceInventoryCap(initiallySelected);
          } else {
            // Single-variant products: enforce using input data attributes
            this.enforceInventoryCapFromInput();
          }
          this.updateB2BTotal();
        }
      }
    }

    handleTriggerClick() {
      this.toggleDropdown();
    }

    handleTriggerKeydown(event) {
      const { key } = event;

      switch (key) {
        case 'Enter':
        case ' ':
        case 'ArrowDown':
          event.preventDefault();
          this.openDropdown();
          this.focusOption(this.activeOptionIndex);
          break;
        case 'ArrowUp':
          event.preventDefault();
          this.openDropdown();
          this.focusOption(this.options.length - 1);
          break;
      }
    }

    handleOptionSelect(index) {
      this.activeOptionIndex = index;
      const option = this.options[index];
      this.updateSelectedOption(option);
      this.closeDropdown();
      this.trigger.focus();

      // Emit custom event for external listeners
      this.dispatchEvent(
        new CustomEvent('variant:change', {
          detail: {
            variantId: option.dataset.variantId,
            price: option.dataset.variantPrice,
            title: option.querySelector('.variant-selector__option-title').textContent.trim(),
          },
          bubbles: true,
        })
      );

      // Recompute B2B total and inventory cap
      if (this.b2b) {
        this.enforceInventoryCap(option);
        this.updateB2BTotal();
      }
    }

    handleOptionKeydown(event, index) {
      const { key } = event;

      switch (key) {
        case 'ArrowDown':
          event.preventDefault();
          const nextIndex = (index + 1) % this.options.length;
          this.focusOption(nextIndex);
          break;
        case 'ArrowUp':
          event.preventDefault();
          const prevIndex = index === 0 ? this.options.length - 1 : index - 1;
          this.focusOption(prevIndex);
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          this.handleOptionSelect(index);
          break;
        case 'Escape':
          event.preventDefault();
          this.closeDropdown();
          this.trigger.focus();
          break;
      }
    }

    handleOutsideClick(event) {
      if (!this.contains(event.target) && this.isOpen) {
        this.closeDropdown();
      }
    }

    toggleDropdown() {
      if (this.isOpen) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }

    openDropdown() {
      if (this.isOpen) return;

      this.isOpen = true;
      this.selector.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');

      // Enable keyboard navigation for options
      this.options.forEach((option, index) => {
        option.tabIndex = index === this.activeOptionIndex ? 0 : -1;
      });
    }

    closeDropdown() {
      if (!this.isOpen) return;

      this.isOpen = false;
      this.selector.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');

      // Disable keyboard navigation for options
      this.options.forEach((option) => {
        option.tabIndex = -1;
      });
    }

    focusOption(index) {
      if (index < 0 || index >= this.options.length) return;

      this.activeOptionIndex = index;
      this.options.forEach((option, i) => {
        option.tabIndex = i === index ? 0 : -1;
      });
      this.options[index].focus();
    }

    handleQuantityDecrease() {
      if (!this.quantityInput) return;

      const currentValue = parseInt(this.quantityInput.value) || 1;
      const step = parseInt(this.quantityMinusBtn.dataset.change) || -1;
      const min = parseInt(this.quantityInput.min) || 1;

      const newValue = Math.max(min, currentValue + step);
      this.quantityInput.value = newValue;
      this.updateQuantityButtons();
      if (this.b2b) this.updateB2BTotal();
    }

    handleQuantityIncrease() {
      if (!this.quantityInput) return;

      const currentValue = parseInt(this.quantityInput.value) || 1;
      const step = parseInt(this.quantityPlusBtn.dataset.change) || 1;
      const max = this.quantityInput.max ? parseInt(this.quantityInput.max) : null;

      const newValue = max ? Math.min(max, currentValue + step) : currentValue + step;
      this.quantityInput.value = newValue;
      this.updateQuantityButtons();
      if (this.b2b) this.updateB2BTotal();
    }

    handleQuantityChange() {
      this.validateQuantity();
      this.updateQuantityButtons();
      if (this.b2b) this.updateB2BTotal();
    }

    validateQuantity() {
      if (!this.quantityInput) return;

      const value = parseInt(this.quantityInput.value) || 1;
      const min = parseInt(this.quantityInput.min) || 1;
      const max = this.quantityInput.max ? parseInt(this.quantityInput.max) : null;

      let validValue = Math.max(min, value);
      if (max) {
        validValue = Math.min(max, validValue);
      }

      if (value !== validValue) {
        this.quantityInput.value = validValue;
      }
    }

    updateQuantityButtons() {
      if (!this.quantityInput || !this.quantityMinusBtn || !this.quantityPlusBtn) return;

      const currentValue = parseInt(this.quantityInput.value) || 1;
      const min = parseInt(this.quantityInput.min) || 1;
      const max = this.quantityInput.max ? parseInt(this.quantityInput.max) : null;

      // Update minus button state
      this.quantityMinusBtn.disabled = currentValue <= min;

      // Update plus button state
      this.quantityPlusBtn.disabled = max ? currentValue >= max : false;
    }

    async handleFormSubmit(event) {
      event.preventDefault();

      if (!this.variantInput || !this.submitButton) {
        return;
      }

      const variantId = this.variantInput.value;
      const quantity = this.quantityInput ? this.quantityInput.value : '1';

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      // Show loading state
      const originalText = this.submitButton.innerHTML;
      this.submitButton.innerHTML = 'Adding...';
      this.submitButton.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          const cart = await response.json();

          // Show success state briefly
          this.submitButton.innerHTML = 'Added!';

          // Emit cart update event
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: { cart },
            })
          );

          // Reset button after 1.5 seconds
          setTimeout(() => {
            this.submitButton.innerHTML = originalText;
            this.submitButton.disabled = false;
          }, 1500);
        } else {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Failed to add to cart');
        }
      } catch (error) {
        this.submitButton.innerHTML = 'Error - Try Again';

        setTimeout(() => {
          this.submitButton.innerHTML = originalText;
          this.submitButton.disabled = false;
        }, 2000);
      }
    }

    updateSelectedOption(selectedOption) {
      // Update aria-selected states
      this.options.forEach((option) => {
        option.setAttribute('aria-selected', option === selectedOption ? 'true' : 'false');
      });

      // Update trigger label
      const title = selectedOption.querySelector('.variant-selector__option-title').textContent.trim();
      this.label.textContent = title;

      // Update form variant ID
      if (this.variantInput) {
        this.variantInput.value = selectedOption.dataset.variantId;
      }

      // Update product image if variant has a different image
      if (this.productImage && selectedOption.dataset.variantImage) {
        const currentImageId = this.productImage.dataset.imageId;
        const variantImageId = selectedOption.dataset.variantImage;

        if (currentImageId !== variantImageId) {
          // This is a placeholder for image updating logic
          // In a real implementation, you'd fetch the new image URL and update the src
        }
      }

      // Update B2B price on card if present
      if (this.b2b) this.updateB2BTotal();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleOutsideClick.bind(this));
    }

    // Helpers: B2B total using quantity breaks
    getVariantBreakData(variantId) {
      const container = this.closest('.product-card')?.querySelector('.product-card__variant-price-data');
      if (!container) return { priceCents: 0, breaks: [] };
      const node = container.querySelector(`[data-variant-id="${variantId}"]`);
      if (!node) return { priceCents: 0, breaks: [] };
      const priceCents = parseInt(node.getAttribute('data-price-cents') || '0', 10);
      const spans = node.querySelectorAll('.break');
      const breaks = [];
      spans.forEach((el) => {
        const min = parseInt(el.getAttribute('data-minimum-quantity') || '0', 10);
        const p = parseInt(el.getAttribute('data-price') || '0', 10);
        if (min > 0 && p > 0) breaks.push({ minimum_quantity: min, price_cents: p });
      });
      breaks.sort((a, b) => a.minimum_quantity - b.minimum_quantity);
      return { priceCents, breaks };
    }

    formatCurrency(cents) {
      try {
        const currency = this.closest('.product-card')?.getAttribute('data-currency') || 'USD';
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency,
          minimumFractionDigits: 0,
        }).format((cents || 0) / 100);
      } catch (_) {
        return `$${((cents || 0) / 100).toFixed(2)}`;
      }
    }

    updateB2BTotal() {
      if (!this.cardPriceEl) return;
      const variantId = this.variantInput?.value || this.options?.[this.activeOptionIndex]?.dataset.variantId;
      if (!variantId) return;
      const qty = parseInt(this.quantityInput?.value || '1', 10) || 1;
      const data = this.getVariantBreakData(variantId);
      let unit = data.priceCents;
      if (data.breaks.length > 0) {
        const applicable = data.breaks.filter((b) => qty >= b.minimum_quantity && b.price_cents > 0);
        if (applicable.length > 0) unit = applicable[applicable.length - 1].price_cents;
      }
      const total = unit * qty;
      this.cardPriceEl.textContent = this.formatCurrency(total);
    }

    enforceInventoryCap(selectedOption) {
      const invQty = parseInt(selectedOption?.dataset.variantInventoryQuantity || '0', 10);
      const invPolicy = (selectedOption?.dataset.variantInventoryPolicy || '').toLowerCase();
      const qtyInput = this.quantityInput;
      if (!qtyInput) return;
      const increment = parseInt(qtyInput.step || '1', 10) || 1;
      let hardMax = qtyInput.max ? parseInt(qtyInput.max, 10) : null;
      if (invPolicy === 'deny' && invQty > 0) {
        const maxByInv = Math.floor(invQty / increment) * increment;
        hardMax = hardMax == null ? maxByInv : Math.min(hardMax, maxByInv);
      }
      if (hardMax != null && hardMax > 0) {
        qtyInput.max = String(hardMax);
        const cur = parseInt(qtyInput.value || '1', 10) || 1;
        if (cur > hardMax) qtyInput.value = String(hardMax);
      } else {
        qtyInput.removeAttribute('max');
      }
      this.updateQuantityButtons();
    }

    enforceInventoryCapFromInput() {
      const qtyInput = this.quantityInput;
      if (!qtyInput) return;
      const invQty = parseInt(qtyInput.getAttribute('data-inventory-quantity') || '0', 10);
      const invPolicy = (qtyInput.getAttribute('data-inventory-policy') || '').toLowerCase();
      const increment = parseInt(qtyInput.step || '1', 10) || 1;
      let hardMax = qtyInput.max ? parseInt(qtyInput.max, 10) : null;
      if (invPolicy === 'deny' && invQty > 0) {
        const maxByInv = Math.floor(invQty / increment) * increment;
        hardMax = hardMax == null ? maxByInv : Math.min(hardMax, maxByInv);
      }
      if (hardMax != null && hardMax > 0) {
        qtyInput.max = String(hardMax);
        const cur = parseInt(qtyInput.value || '1', 10) || 1;
        if (cur > hardMax) qtyInput.value = String(hardMax);
      } else {
        qtyInput.removeAttribute('max');
      }
      this.updateQuantityButtons();
    }
  }

  // Register the custom element only if it doesn't exist
  if (!customElements.get('product-card-form')) {
    customElements.define('product-card-form', ProductCardForm);
  }

  // Initialize product card forms when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    // Find all product cards with form functionality enabled
    const productCards = document.querySelectorAll('.product-card');

    productCards.forEach((card) => {
      const form = card.querySelector('.product-card__form');
      const variants = card.querySelector('.product-card__variants');

      // Only wrap if there's a form (indicating form functionality is enabled)
      if (form && !form.closest('product-card-form')) {
        const wrapper = document.createElement('product-card-form');

        // Insert wrapper before the form
        form.parentNode.insertBefore(wrapper, form);

        // Move variant selector into wrapper first (if it exists)
        if (variants) {
          wrapper.appendChild(variants);
        }

        // Move form into wrapper last (so button stays at bottom)
        wrapper.appendChild(form);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
